import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { connect } from 'react-redux';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import {
    fetchCommitteesMembers,deleteCommitteeMember
} from '../../../../../../Redux/Actions/Admin/ManageCommitteeMemberAction'
import { Switch } from '@progress/kendo-react-inputs';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import Search from '../../../../Search';
import GridDateFormatter  from '../../../../GridDateFormatter';
import cellWithEditing from './CellWithEditing';

class CommitteeMembers extends Component {
	constructor(props) {
        super(props);
		this.state = {
            toggled: true,
            filter: {
                logic: 'and',
                filters: [ { field: 'isActive', operator: 'eq', value: true, ignoreCase: true } ]
            },
            filteredCommitteeMembers: [],
            displayData: [],
            filteredData: [],
            allData: [],
            skip: 0,
            take: 10,
            visible: false,
            sort: [ { field: 'Title', dir: 'asc' } ],
            committeeMemberInEdit: undefined,
          
		};
	}

	componentDidMount() {     
        this.props.fetchCommitteesMembers(this.props.committeeId).then(() => {

            this.setState({
                allData: this.props.committeeMembers.committeeMembers,
                isLoading: false
            });

            let filterData = filterBy(
                orderBy(
                    this.state.allData,
                    this.state.sort
                ),
                this.state.filter
            );

            this.setState({
                filteredData: filterData,
                displayData: filterData.slice(this.state.skip, this.state.take + this.state.skip)
            });
        });
	}

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });

        let filterdata = this.state.filteredData.slice(event.page.skip, event.page.take + event.page.skip);

        this.setState({
            displayData: filterdata
        })
    }

    filterAndSortData = () => {
        let filterData = filterBy(
            orderBy(
                this.state.allData,
                this.state.sort
            ),
            this.state.filter
        );

        this.setState({
            filteredData: filterData,
            displayData: filterData.slice(this.state.skip, this.state.take + this.state.skip)
        });
    }

    filter = (filter) => {
        let filterData = filterBy(
            orderBy(
                this.state.allData,
                this.state.sort
            ),
            filter
        );

        this.setState({
            filteredData: filterData,
            displayData: filterData.slice(this.state.skip, this.state.take + this.state.skip)
        });
    }

    sort = (sort) => {
        let filterData = filterBy(
            orderBy(
                this.state.allData,
                sort
            ),
            this.state.filter
        );

        this.setState({
            filteredData: filterData,
            displayData: filterData.slice(this.state.skip, this.state.take + this.state.skip)
        });
    }

    _export;
	export = () => {
		this._export.save();
    };

    toggleActive = (dataItem) => {
        dataItem.isActive = !dataItem.isActive;
        this.props.deleteCommitteeMember(dataItem);
    };

    edit = (dataItem) => {
		this.setState({ committeeMemberInEdit: this.cloneUser(dataItem) });
	};
	cloneUser(committee) {
		return Object.assign({}, committee);
    }
    cancel = () => {
		this.setState({ committeeMemberInEdit: undefined });
	};
    
    handleChange = () => {
        this.setState({ toggled: !this.state.toggled });
		this.setState({
			filter: {
				logic: 'and',
				filters: [ { field: 'isActive', operator: 'eq', value: !this.state.toggled, ignoreCase: true } ]
			}
		});
    }

    filterCommitteeMembers = (searchTerm) => {
		const filterCommitteeMembers = this.props.committeeMembers.committeeMembers.filter((committee) => {
			
			return (
				committee.firstName.toLowerCase().includes(searchTerm) ||
				committee.lastName.toLowerCase().includes(searchTerm) ||
				committee.committeeName.toLowerCase().includes(searchTerm) ||
				committee.positionName.toLowerCase().includes(searchTerm) ||
                committee.positionGroupName.toLowerCase().includes(searchTerm) ||
                committee.email.toLowerCase().includes(searchTerm) 
			);
		});
		this.setState({ filteredCommitteeMembers: filterCommitteeMembers });
		if (searchTerm === '') {
			this.setState({ filteredCommitteeMembers: [] });
		}
    }

	render() {
        // console.log("Committee Member grid data", this.props.committeeMembers.committeeMembers);
        const activeMembers = this.props.committeeMembers.committeeMembers.filter((members) => members.isActive === true);
        const inActiveMembers = this.props.committeeMembers.committeeMembers.filter((members) => members.isActive !== true);
		return (
            <React.Fragment>
           
                <div style={{width: '100%'}}>
           <h3 className="highlight">MEMBERS LIST</h3>
           <ExcelExport
               data={this.state.displayData}
               ref={(exporter) => {
                   this._export = exporter;
               }}
           >
               <ExcelExportColumn field="firstName" title="First Name" />
               <ExcelExportColumn field="lastName" title="Last Name" />
               <ExcelExportColumn field="committeeName" title="Committee Name" />
               <ExcelExportColumn field="positionName" title="Position" />
               <ExcelExportColumn field="positionGroupName" title="Position Group" />
               <ExcelExportColumn field="email" title="Email" />
               <ExcelExportColumn field="begDate" title="Beginning Date" />
               <ExcelExportColumn field="endDate" title="End Date" />
               <ExcelExportColumn field="isActive" title="Active Member" />
           </ExcelExport>
           {this.props.common.loading ? (
               <IsLoading message="Loading Committee Members" />
           ) : (
               <Grid
                   style={{ width: 'auto', height: '80vh' }}
                   //data={
                   //    typeof this.state.filter.filters[0].value !== 'boolean' ? (
                   //        filterBy(
                   //         this.state.filteredCommitteeMembers.length ? this.state.filteredCommitteeMembers : this.props.committeeMembers.committeeMembers,
                   //            this.state.filter
                   //        ).slice(this.state.skip, this.state.take + this.state.skip)
                   //    ) : (
                   //        orderBy(
                   //         this.state.filteredCommitteeMembers.length
                   //                ? this.state.filteredCommitteeMembers
                   //                : this.state.toggled ? activeMembers : inActiveMembers,
                   //            this.state.sort
                   //        ).slice(this.state.skip, this.state.take + this.state.skip)
                   //    )
                   //}
                   data={this.state.displayData}
                   sortable
                   sort={this.state.sort}
                   onSortChange={(e) => {
                       this.setState({
                           sort: e.sort
                       });
                       this.sort(e.sort);
                   }}
                   filterable
                   filter={this.state.filter}
                   onFilterChange={(e) => {
                       this.setState({
                           filter: e.filter
                       });

                       this.filter(e.filter); 
                   }}
                   skip={this.state.skip}
                   take={this.state.take}
                   total={this.state.filteredData.length}
                   pageable={true}
                   onPageChange={this.pageChange}
                   resizable
                   reorderable={true}
               >
                   <GridToolbar>
                           <div className="admin-grid-toolbar-box2" style={{ width: "100%"}}>
                               <button title="Export PDF" style={{ width: "auto" }} className="admin-k-button" onClick={this.export}>
                               <i className="fas fa-file-export"></i>
                               {this.state.filteredCommitteeMembers.length || this.state.filter.filters[1] ? (
                                   'EXPORT TO EXCEL'
                               ) : (
                                   'EXPORT ALL'
                               )}
                           </button>
                       </div>
                    </GridToolbar>
                    <Column filterable={false} cell={cellWithEditing(this.toggleActive)} />
                    <Column field="firstName" title="First Name" filter="text" />
                    <Column field="lastName" title="Last Name" filter="text"/>
                    <Column field="committeeName" title="Committee Name" filter="text" />
                    <Column field="positionName" title="Position" filter="text" />
                    <Column field="positionGroupName" title="Position Group" filter="text"/>
                    <Column field="email" title="Email" filter="text"/>
                    <Column field="begDate" title="Beginning Date" cell={GridDateFormatter}/>
                    <Column field="endDate" title="End Date" cell={GridDateFormatter}/>
                    <Column field="isActive" title="Active Member" filterable={false} className="isActive-column" />
               </Grid>
           )}
           
       </div>
       </React.Fragment>
		);
	}
}

function mapStateToProps(state) {
    console.log(state)
	return {
        common: state.common,
        committeeMembers : state.committeeMember
	};
}

export default connect(mapStateToProps, {fetchCommitteesMembers,deleteCommitteeMember})(CommitteeMembers);